import { NoopScrollStrategy } from '@angular/cdk/overlay';
import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { ComponentType } from '@angular/cdk/portal';
import { Subject } from 'rxjs';

@Injectable()
export class DialogService {
  constructor(
    @Inject(DOCUMENT) private document: Document,
    private dialog: MatDialog
  ) {}

  /**
   * Wraps material dialog.open to customize opening/closing animations.
   * Current solution implements css opening animation
   */
  open<T, D = any, R = any>(component: ComponentType<T>, config: MatDialogConfig<D> = {}): MatDialogRef<T, R> {
    const animationClass = 'fadeIn';

    const dialogRef = this.dialog.open(component, { ...config, scrollStrategy: new NoopScrollStrategy() });

    dialogRef.addPanelClass(animationClass);

    const backdrop = document.querySelector('.cdk-overlay-backdrop') as HTMLElement;
    const container = document.querySelector('.mat-mdc-dialog-container') as HTMLElement;
    const wrapper = document.querySelector('.cdk-global-overlay-wrapper') as HTMLElement;

    const afterClosed = new Subject();
    dialogRef.afterClosed = () => afterClosed.asObservable();

    const closeFunction = dialogRef.close;
    const closeHandler = (dialogResult?: any) => {
      afterClosed.next(dialogResult);

      wrapper.style.display = 'none';
      backdrop.style.display = 'none';
      dialogRef.close = closeFunction;
      dialogRef.close(dialogResult);
    };
    dialogRef.close = (dialogResult?: any) => closeHandler(dialogResult);

    if (!config.disableClose) {
      container.addEventListener('click', e => e.stopPropagation());
      wrapper.addEventListener('click', () => closeHandler());
    }

    return dialogRef;
  }

  toggleOpenClassOnBodyListeners() {
    this.dialog.afterOpened.subscribe(() => this.document.body.classList.add('modal-open'));
    this.dialog.afterAllClosed.subscribe(() => this.document.body.classList.remove('modal-open'));
  }
}
